import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'input',
      label: '标题',
      placeholder: '请输入标题',
      rules: { required: true, message: '标题是必传的', trigger: 'blur' }
    },
    {
      field: 'url',
      type: 'input',
      label: '访问链接',
      placeholder: '请输入访问链接',
      rules: { required: true, message: '访问链接是必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
